
import { supabase } from '@/integrations/supabase/client';

export async function ensureAvatarBucketExists() {
  try {
    // Check if the bucket exists
    const { data: buckets } = await supabase.storage.listBuckets();
    const avatarBucketExists = buckets?.some(bucket => bucket.name === 'avatars');
    
    if (!avatarBucketExists) {
      // Create the bucket if it doesn't exist
      const { error } = await supabase.storage.createBucket('avatars', {
        public: true, // Make bucket public
        fileSizeLimit: 1024 * 1024 * 2, // 2MB
      });
      
      if (error) {
        console.error('Error creating avatars bucket:', error);
      } else {
        console.log('Avatars bucket created successfully');
      }
    }
  } catch (error) {
    console.error('Error ensuring avatar bucket exists:', error);
  }
}
